const snakeCaseToTitleCase = (inputString) => {
    const words = inputString.split('_');
    const titleCaseString = words
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  
    return titleCaseString;
  }

export default snakeCaseToTitleCase;